import { useState } from 'react';
import styled from '@emotion/styled';

import { Tooltip, Box } from '@mui/material';

export const BoxLink = styled(Box)(`
    font-size: .9375rem;
    position: relative;
    font-weight: 700;
    color: white;
    display: flex;
    height: 40px;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    border: 2px solid #FFFFFF;
    margin-bottom: .9375rem;

    svg {
        position: absolute;
        right: 1rem;
        height: 1.2rem;
        path {
            fill: #FFFFFF;
        }
    }
`);

const ButtonCopyWebView = ({ text, link }: { text: string; link: string }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleCopied = () => {
        setIsOpen(true);
        setTimeout(() => {
            setIsOpen(false);
        }, 1500);
    }

    return (
        <Tooltip
            PopperProps={{
                disablePortal: true,
            }}
            open={isOpen}
            placement="top"
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title="Copiado"
            onClick={() => { handleCopied(); navigator.clipboard.writeText(link); }}
        >
            <BoxLink id='btn-copy'>
                {text}
                {/* <IcCopyAndPasteTicket /> */}
            </BoxLink>
        </Tooltip>
    )
}

export default ButtonCopyWebView;